// @file Captures UTM query parameters and strips them from the URL before other JS runs.
// Loaded synchronously from shared/pepin_analytics.
// @see https://www.rudderstack.com/docs/event-spec/standard-events/common-fields/#contextcampaign
import window from '@@/bits/global'

const UTM_SEARCH_PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'] as const

const UTM_TO_CAMPAIGN_KEY: ReadonlyArray<readonly [string, string]> = [
  ['utm_source', 'source'],
  ['utm_medium', 'medium'],
  ['utm_campaign', 'name'],
  ['utm_term', 'term'],
  ['utm_content', 'content'],
]

function captureUtmParams(): Record<string, string> | null {
  const params = new URLSearchParams(window.location.search)
  const campaign: Record<string, string> = {}
  for (const [utmKey, campaignKey] of UTM_TO_CAMPAIGN_KEY) {
    const value = params.get(utmKey)
    if (value != null && value !== '') {
      campaign[campaignKey] = value
    }
  }
  return Object.keys(campaign).length > 0 ? campaign : null
}

function hasUtmInUrl(): boolean {
  const params = new URLSearchParams(window.location.search)
  return UTM_SEARCH_PARAM_KEYS.some((key) => params.get(key) != null)
}

function stripUtmParamsFromUrl(): void {
  if (!hasUtmInUrl()) return
  const url = new URL(window.location.href)
  for (const key of UTM_SEARCH_PARAM_KEYS) {
    url.searchParams.delete(key)
  }
  history.replaceState(null, '', url.toString())
}

window.$utmParams = captureUtmParams()
stripUtmParamsFromUrl()
